import { logout, userLoading, userLoadFailed, userLoaded } from '../actions/auth';
import { api } from '../api/index';
import { GetCookie, RemoveCookie } from '../../utils/cookie';
import { currentApp } from '../apps';

export const Logout = () => async (dispatch: any) => {
    try {
        RemoveCookie(currentApp().refreshCookie);
        dispatch(logout());
    } catch (error) {
        dispatch(logout());
        RemoveCookie(currentApp().refreshCookie);
        // toast.error('Неизвестная ошибка');
    }
};

export const LoadUser = () => async (dispatch: any) => {
    dispatch(userLoading());
    let language = localStorage.getItem('language');
    if (!language) {
        language = 'tkm';
        localStorage.setItem('language', 'tkm');
    }
    const token = GetCookie(currentApp().refreshCookie);
    try {
        if (token) {
            const response = await api.get({ url: '/api/v1/auth/load-user', token });
            dispatch(userLoaded(response.data));
        } else {
            dispatch(userLoadFailed());
        }
    } catch (error) {
        dispatch(userLoadFailed());
        // toast.error('Неизвестная ошибка');
    }
};
